export default "__VITE_PUBLIC_ASSET__aac7688f__"